import { Directive, Input } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, Validator, ValidatorFn, Validators } from '@angular/forms';

/**
 * Check if input contains digits only
 *
 * @param {string} allowedCharacters
 * @returns {ValidatorFn}
 */
export function validateNumericCharacters(allowedCharacters: string): ValidatorFn {

    return (control: AbstractControl): { [key: string]: any } => {

        //Regex to only allow numbers
        const regex = new RegExp('^[0-9]*$');

        if (!control.value) {
            return null;
        }

        if (regex.test(control.value)) {
            return null;
        }

        return {'validateNumericCharacters': {value: control.value}};
    };
}


@Directive({
    selector: '[validateNumericCharacters]',
    providers: [{provide: NG_VALIDATORS, useExisting: NumericValidatorDirective, multi: true}]
})
export class NumericValidatorDirective implements Validator {
    @Input() allowedCharacters: string;

    validate(control: AbstractControl): { [key: string]: any } {

        return validateNumericCharacters(this.allowedCharacters)(control);
    }
}



// WEBPACK FOOTER //
// /home/forge/dev-client-app.instaveritas.com/releases/20231127121751/src/app/common/validators/numeric-validator.directive.ts